import { Displaying, Spacing } from "@bonusx-global/bx-design-system";
import Box from "@mui/material/Box";
import { useMemo } from "react";
import useIsMobile from "../../../../../hooks/device/useIsMobile";
import { type IHeaderV2LayoutStore } from "../../stores/header-v2-layout-store";
import { renderHeaderV2ActionIcon } from "../utils/render-header-v2-action-icon/render-header-v2-action-icon";
import { HeaderActionsManager } from "./header-actions-manager/header-actions-manager";

type HeaderV2ActionsProps = Pick<IHeaderV2LayoutStore, "actions">;

function HeaderV2Actions({ actions }: Readonly<HeaderV2ActionsProps>): JSX.Element {
  const isMobile = useIsMobile();

  const actionsWithoutSearchInDesktop = useMemo(
    function recalculateAction() {
      const headerActionsManager = new HeaderActionsManager({ actions, isMobile });
      return headerActionsManager.filteredActions;
    },
    [actions, isMobile]
  );

  return (
    <Box display={Displaying.flex} gap={Spacing["750"]}>
      {actionsWithoutSearchInDesktop?.map(renderHeaderV2ActionIcon)}
    </Box>
  );
}

export default HeaderV2Actions;
